import ProductState from "@/models/Products/ProductState";

export default (val: ProductState) => {
    let returnVal = "Undefined";
    switch (val) {
        case ProductState.Pending:
            returnVal = "Pending"
            break;
        case ProductState.Published:
            returnVal = "Published"
            break;
        case ProductState.Withdrawn:
            returnVal = "Withdrawn"
            break;
    }
    return returnVal;
}